import './ByzzerOshMarketCheckbox.scss';
import React, { useState } from 'react';
import { ByzzerCheckbox } from '@byzzer/ui-components';
import classNames from 'classnames';

export type TreeNode = {
    name: string;
    id: string;
    isFolder: boolean;
    isSelectable: boolean;
    isExpanded?: boolean;
    children?: TreeNode[];
    value: string;
    metaData?: Record<string, any>;
};

type ByzzerOshMarketCheckboxProps = {
    node: TreeNode;
    value?: string[];
    disabledMarkets?: string[];
    onSelect?: (node: TreeNode, checked: boolean) => void;
};

const ByzzerOshMarketCheckbox: React.FC<ByzzerOshMarketCheckboxProps> = ({
    node,
    onSelect,
    value,
    disabledMarkets,
}) => {
    const [isExpanded, setIsExpanded] = useState(!!node.isExpanded);

    const handleToggle = () => {
        setIsExpanded(!isExpanded);
    };

    const handleSelect = (checked: boolean) => {
        onSelect?.(node, checked);
    };

    return (
        <div className="osh-market-checkbox">
            <div
                className={classNames('osh-market-checkbox__item', {
                    'osh-market-checkbox__item--disabled': disabledMarkets?.includes(node.value),
                })}
            >
                {node.isFolder && (
                    <span
                        className={`osh-market-checkbox__icon ${
                            isExpanded ? 'osh-market-checkbox__icon--expanded' : 'osh-market-checkbox__icon--collapsed'
                        }`}
                        onClick={handleToggle}
                    />
                )}
                {node.isSelectable && (
                    <ByzzerCheckbox
                        name={node.id}
                        onChange={(e) => handleSelect(e.checked)}
                        checked={value?.includes(node.value)}
                        disabled={disabledMarkets?.includes(node.value)}
                    />
                )}
                <span className="osh-market-checkbox__label">{node.name}</span>
            </div>

            {node.isFolder && isExpanded && node.children && (
                <div className="osh-market-checkbox__children">
                    {node.children.map((child) => (
                        <ByzzerOshMarketCheckbox
                            key={child.id}
                            node={child}
                            onSelect={onSelect}
                            value={value}
                            disabledMarkets={disabledMarkets}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default ByzzerOshMarketCheckbox;
